import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "d-flex justify-content-center mt-3" }
const _hoisted_3 = { class: "text-center mt-3" }

import PopupWrapper from "@/components/PopupWrapper.vue";
import {reactive} from "@vue/reactivity";
import {ref} from "vue";
import StoreItemDTO from "@/models/StoreItemDTO";
import CoinsBundle from "@/components/store/CoinsBundle.vue";
import {api} from "@/service/APIClient";
import LoaderContent from "@/components/LoaderContent.vue";
import PurchaseCreateRequestDTO from "@/models/request/PurchaseCreateRequestDTO";
import {useStore} from "vuex";
import { AppEvents } from "@/models/enum/AppEvents";
import LootBoxBundle from "@/components/store/LootBoxBundle.vue";
import {PurchasableItemContentType} from "@/models/enum/PurchasableItemContentType";


export default /*@__PURE__*/_defineComponent({
  __name: 'InternalStorePopup',
  setup(__props, { expose: __expose }) {

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const store = useStore();
const state = reactive({
  purchase: null as any,
  item: null as StoreItemDTO|null
})

const show = (item: StoreItemDTO) => {
  state.item = item
  popup.value?.show()
}

const onShown = () => {
  loader.value?.load(async () => {
    state.purchase = await api.call.purchases.create({
      itemId: state.item!.id,
      provider: "SELF"
    } as PurchaseCreateRequestDTO)
  });
}

const hide = () => {
  popup.value?.hide()
}

const success = () => {
  loader.value?.load(async () => {
    const purchaseId = state.purchase!.id;
    await api.call.purchases.complete(state.purchase!.id)
    hide()
    store.dispatch('emit', {
      event: AppEvents.PURCHASE_COMPLETED, data: {
        purchaseId,
        item: state.item
      }
    })
  });
}

const fail = () => {
  hide()
}

const cancel = () => {
  loader.value?.load(async () => {
    const purchaseId = state.purchase!.id;
    await api.call.purchases.cancel(state.purchase!.id)
    hide()
    store.dispatch('emit', {
      event: AppEvents.PURCHASE_CANCELED, data: {
        purchaseId,
        item: state.item
      }
    })
  });
}

__expose({ show, hide })
const popup = ref<InstanceType<typeof PopupWrapper> | null>(null)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupWrapper, {
    hide: cancel,
    title: "Internal Store",
    ref: (el) => popup.value = el,
    class: "internal-store popup-float",
    "hide-close-btn": false
  }, {
    default: _withCtx(() => [
      _createVNode(LoaderContent, {
        ref: (el) => {loader.value = el; onShown()}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_unref(state).item?.type === _unref(PurchasableItemContentType).COINS)
                ? (_openBlock(), _createBlock(CoinsBundle, {
                    key: 0,
                    item: _unref(state).item,
                    "buy-btn-disabled": true
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              (_unref(state).item?.type === _unref(PurchasableItemContentType).LOOT_BOX)
                ? (_openBlock(), _createBlock(LootBoxBundle, {
                    key: 1,
                    item: _unref(state).item,
                    "buy-btn-disabled": true
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, "Purchase ID: " + _toDisplayString(_unref(state).purchase?.id), 1),
            _createElementVNode("button", {
              onClick: success,
              class: "btn btn-primary mt-3"
            }, "Process purchase"),
            _createElementVNode("button", {
              onClick: fail,
              class: "btn btn-danger mt-3"
            }, "Fail purchase"),
            _createElementVNode("button", {
              onClick: cancel,
              class: "btn btn-secondary mt-3"
            }, "Cancel purchase")
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 512))
}
}

})